/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCountryDto
 */
export interface CreateCountryDto {
    /**
     * 3-character country code
     * @type {string}
     * @memberof CreateCountryDto
     */
    code: string;
    /**
     * Country name
     * @type {string}
     * @memberof CreateCountryDto
     */
    name: string;
    /**
     * URL of the country flag or representative image
     * @type {string}
     * @memberof CreateCountryDto
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the CreateCountryDto interface.
 */
export function instanceOfCreateCountryDto(value: object): value is CreateCountryDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateCountryDtoFromJSON(json: any): CreateCountryDto {
    return CreateCountryDtoFromJSONTyped(json, false);
}

export function CreateCountryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCountryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

  export function CreateCountryDtoToJSON(json: any): CreateCountryDto {
      return CreateCountryDtoToJSONTyped(json, false);
  }

  export function CreateCountryDtoToJSONTyped(value?: CreateCountryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'imageUrl': value['imageUrl'],
    };
}

